import { atlasRoutes } from "@/app/router/routes";
import { LookupByUuidForm } from "@/components/forms/lookup-by-uuid-form";
import { FC } from "react";
import { useNavigate } from "react-router";
import { Button } from "@radix-ui/themes";
import styled from "@emotion/styled";

export const BatchAccountUpgradeRootPage: FC = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <h1>Batch Account Upgrades</h1>

      <Section>
        <h2>Find a Batch Account Upgrade</h2>
        <LookupByUuidForm
          onSubmit={uuid =>
            navigate(
              atlasRoutes.batchAccountUpgradesView({ params: { batchAccountUpgradeId: uuid } }).path
            )
          }
        />
      </Section>

      <Section>
        <h2>Or Create a New One</h2>
        <Button onClick={() => navigate(atlasRoutes.batchAccountUpgradeCreate({}).path)}>
          Create Batch Account Upgrade
        </Button>
      </Section>
    </Container>
  );
};

const Container = styled.div`
  padding: 20px;
`;

const Section = styled.div`
  margin-bottom: 30px;
`;
